export type DomainKey = string;

export const DEFAULT_DOMAIN: DomainKey = 'onboarding.ccs.ag';

/**
 * Check if hostname is localhost or development environment
 */
export function isLocalhost(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.');
}
